// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";
// import { FaLocationDot } from "react-icons/fa6";
import { ENQUIRY_CTA } from "../constants";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="../Assets/banner2.webp"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            SHAHRUKHZ RESIDENCES BY DANUBE
          </h2>
          {/* <div className="luxury-location flex items-center">
            <FaLocationDot className="text-[#997736] mr-2" />
            <span className="text-[#997736] font-bold text-lg">Emirates Road, Sharjah</span>
          </div> */}
          <p>
            Shahrukhz Residences at Maritime City is a residential building planned by Danube Properties Development at Dubai Maritime City. It entered Dubai regulatory records in September 2026 and is still at planning stage, with no price list, unit sizes, booking amount or handover date released. It would be Danube's fifth tower on the peninsula after Oceanz 1, 2, 3 and Breez. The name comes from a naming collaboration with Shah Rukh Khan. Maritime City is a 249 hectare freehold waterfront district between Port Rashid and Dubai Drydocks, 15 minutes from Downtown Dubai and the Dubai Mall. 
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
